module.exports = __webpack_public_path__ + "img/logo-la-fabrique-numerique.da90b27a.svg";